export default {
  dealers: [],
  dealer: {},
};
